import React from 'react';
import { IntlForm } from 'react-ocean-forms-react-intl';
import { ParameterSearchForm } from './ParameterSearchForm';
import { useParameterContext } from '../../../components/Parameter';


/**
 * @author Jungwirth
 */
export const ParameterSearch: React.FC<{}> = (): JSX.Element => {
  const { setFilter, setResetForm } = useParameterContext();

  return (
    <IntlForm
      onSubmit={setFilter}
      onReset={() => setResetForm()}
    >
      <div style={{ hyphens: 'auto'}}>
        <ParameterSearchForm />
      </div>
    </IntlForm>
  );
};
